import React, { createContext, useContext, useState } from "react";
import { toast } from "sonner";
import { exportSection } from "@/lib/section-export";

export const SectionExportContext = createContext(null);

export default function SectionExport() {
  const context = useContext(SectionExportContext);
  const [busy, setBusy] = useState(false);
  if (!context || context.disabled) return null;
  const run = async (event, format) => {
    event.stopPropagation();
    const section = event.currentTarget.closest("[data-export-section]");
    setBusy(true);
    try {
      await exportSection(section, { ...context, format });
    } catch (error) {
      toast.error(`Export failed: ${error.message}`);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-export-controls className="flex flex-wrap justify-end gap-2 mb-3 print:hidden">
      <button type="button" disabled={busy} onClick={(e) => run(e, "print")}
        className="rounded border border-stone-300 bg-white px-3 py-1.5 text-xs text-stone-700 disabled:opacity-50"
        data-testid="section-print">Print section</button>
      <button type="button" disabled={busy} onClick={(e) => run(e, "pdf")}
        className="rounded border border-brand-700 bg-white px-3 py-1.5 text-xs text-brand-800 disabled:opacity-50"
        data-testid="section-pdf">{busy ? "Preparing…" : "Download PDF"}</button>
    </div>
  );
}